import { render, staticRenderFns } from "./PointWriteWithdrawLayout.vue?vue&type=template&id=3f1811ae&scoped=true"
import script from "./PointWriteWithdrawLayout.vue?vue&type=script&lang=js"
export * from "./PointWriteWithdrawLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1811ae",
  null
  
)

export default component.exports